
import React from 'react';

export const CategoryGrid: React.FC = () => {
  const categories = [
    {
      id: 1,
      name: 'Clothing',
      image: 'https://public.readdy.ai/ai/img_res/bfde6a68f26f1f7c3ec9689ffcb1b3a5.jpg',
      count: '2.5k+ items'
    },
    {
      id: 2,
      name: 'Shoes',
      image: 'https://readdy.ai/api/search-image?query=icon%2C%203D%20cartoon%20shoes%20sneakers%20and%20boots%2C%20the%20icon%20should%20take%20up%2070%25%20of%20the%20frame%2C%20vibrant%20colors%20with%20soft%20gradients%2C%20minimalist%20design%2C%20smooth%20rounded%20shapes%2C%20subtle%20shading%2C%20no%20outlines%2C%20centered%20composition%2C%20isolated%20on%20white%20background%2C%20playful%20and%20friendly%20aesthetic%2C%20isometric%20perspective%2C%20high%20detail%20quality%2C%20clean%20and%20modern%20look%2C%20single%20object%20focus&width=100&height=100&seq=cat2&orientation=squarish',
      count: '1.8k+ items'
    },
    {
      id: 3,
      name: 'Jewelry',
      image: 'https://readdy.ai/api/search-image?query=icon%2C%203D%20cartoon%20jewelry%20rings%20necklaces%20and%20earrings%2C%20the%20icon%20should%20take%20up%2070%25%20of%20the%20frame%2C%20vibrant%20colors%20with%20soft%20gradients%2C%20minimalist%20design%2C%20smooth%20rounded%20shapes%2C%20subtle%20shading%2C%20no%20outlines%2C%20centered%20composition%2C%20isolated%20on%20white%20background%2C%20playful%20and%20friendly%20aesthetic%2C%20isometric%20perspective%2C%20high%20detail%20quality%2C%20clean%20and%20modern%20look%2C%20single%20object%20focus&width=100&height=100&seq=cat3&orientation=squarish',
      count: '950+ items'
    },
    {
      id: 4,
      name: 'Home',
      image: 'https://readdy.ai/api/search-image?query=icon%2C%203D%20cartoon%20household%20items%20including%20furniture%20and%20decor%2C%20the%20icon%20should%20take%20up%2070%25%20of%20the%20frame%2C%20vibrant%20colors%20with%20soft%20gradients%2C%20minimalist%20design%2C%20smooth%20rounded%20shapes%2C%20subtle%20shading%2C%20no%20outlines%2C%20centered%20composition%2C%20isolated%20on%20white%20background%2C%20playful%20and%20friendly%20aesthetic%2C%20isometric%20perspective%2C%20high%20detail%20quality%2C%20clean%20and%20modern%20look%2C%20single%20object%20focus&width=100&height=100&seq=cat4&orientation=squarish',
      count: '3.2k+ items'
    },
    {
      id: 5,
      name: 'Kids',
      image: 'https://readdy.ai/api/search-image?query=icon%2C%203D%20cartoon%20kids%20toys%20and%20clothing%2C%20the%20icon%20should%20take%20up%2070%25%20of%20the%20frame%2C%20vibrant%20colors%20with%20soft%20gradients%2C%20minimalist%20design%2C%20smooth%20rounded%20shapes%2C%20subtle%20shading%2C%20no%20outlines%2C%20centered%20composition%2C%20isolated%20on%20white%20background%2C%20playful%20and%20friendly%20aesthetic%2C%20isometric%20perspective%2C%20high%20detail%20quality%2C%20clean%20and%20modern%20look%2C%20single%20object%20focus&width=100&height=100&seq=cat5&orientation=squarish',
      count: '1.5k+ items'
    },
    {
      id: 6,
      name: 'Beauty',
      image: 'https://readdy.ai/api/search-image?query=icon%2C%203D%20cartoon%20beauty%20products%20cosmetics%20and%20skincare%2C%20the%20icon%20should%20take%20up%2070%25%20of%20the%20frame%2C%20vibrant%20colors%20with%20soft%20gradients%2C%20minimalist%20design%2C%20smooth%20rounded%20shapes%2C%20subtle%20shading%2C%20no%20outlines%2C%20centered%20composition%2C%20isolated%20on%20white%20background%2C%20playful%20and%20friendly%20aesthetic%2C%20isometric%20perspective%2C%20high%20detail%20quality%2C%20clean%20and%20modern%20look%2C%20single%20object%20focus&width=100&height=100&seq=cat6&orientation=squarish',
      count: '800+ items'
    }
  ];

  return (
    <section className="px-4 mb-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-bold text-gray-800">Shop by Category</h2>
        <button className="text-emerald-500 text-sm font-medium">View All</button>
      </div>
      
      <div className="grid grid-cols-3 gap-4">
        {categories.map((category) => (
          <div
            key={category.id}
            className="bg-white rounded-2xl p-4 shadow-sm border border-gray-50 hover:shadow-md transition-shadow"
          >
            <div className="w-16 h-16 mx-auto mb-3 rounded-xl overflow-hidden">
              <img
                src={category.image}
                alt={category.name}
                className="w-full h-full object-cover"
              />
            </div>
            <h3 className="text-center text-sm font-semibold text-gray-800 mb-1 whitespace-nowrap overflow-hidden text-ellipsis">
              {category.name}
            </h3>
            <p className="text-center text-xs text-gray-500 whitespace-nowrap overflow-hidden text-ellipsis">
              {category.count}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
};
